import { useState, useEffect, useCallback } from 'react';
import { fetchJson } from '../../../helpers/index.js';
import { buildCellClassRules, buildValueGetter } from './dynamicValueHelpers.js';

import {
  datagrid_get_import_config_path
} from '~/routes';

import { convertKeys } from './helpers.js';

export default function usePersistentConfig(
  settings, 
  updateSettings, 
  context, 
  gridApi, 
  validateAllColumns, 
  columns
) {

  const [allConfigs, setAllConfigs] = useState([]);
  const [selectedColConfig, setSelectedColConfig] = useState(null);

  // Update the value getters to ag-grid coldefs
  const updateValueGetters = useCallback((columnImportConfigs) => {
        let colDefs = gridApi.getGridOption('columnDefs');
        columns.forEach(column => {
          const colDef = colDefs.find(colDef => colDef.field == column.accessor);
          const columnImportConfig = columnImportConfigs[column.accessor] || {};
          colDef.valueGetter = buildValueGetter(column, columnImportConfig);
          colDef.cellClassRules = buildCellClassRules(column, columnImportConfig)
        })
        gridApi.setGridOption('columnDefs', colDefs)
  }, [gridApi, columns]);

  useEffect(() => {
    if (context.permissions['view_import_config']){
      fetchJson(datagrid_get_import_config_path({project_id: context.project_id, id: context.id, _options: true})).then(res => {
        setAllConfigs(res)      
      })
    }
  }, [])

  useEffect(() => {
    let chosenConfig = ((allConfigs || []).find((c) => c.id == selectedColConfig) || {}).configuration;
    if (chosenConfig){
      // When save to db attrs are stringify so need convert back by key specific mapping
      chosenConfig = convertKeys(
        chosenConfig, 
        {excel_column: 'integer', ignore_blanks: 'boolean'},
        {ignore_blanks: false}
      )
      updateSettings({columns: chosenConfig});
      updateValueGetters(chosenConfig);
      validateAllColumns();
    }
  }, [selectedColConfig])

  return {
    allConfigs, setAllConfigs, selectedColConfig, setSelectedColConfig
  }
}